<template>
    <div>
        <div class="box_01_02">
            <span class="box_01_03">上传互动包</span>
            <w-upload-file

                style="overflow: hidden;"
                :videoWidth="1920"
                :videoHeight="620"
                :size="10"
                accept=".zip"
                btnText='上传互动包'
                tipsText="zip格式"
                @input="zipInfo"
                v-model="value.zipUrl">
            </w-upload-file>
        </div>
        <el-form-item label="互动内跳转" class="jump-link-group">
          <el-radio-group class="art-radio-group" :class="{'disabled-box': isDisabledRadio}" v-model="value.jump_type" :disabled="isDisabledRadio" size="small">
            <el-radio-button v-for="(el,index) in btns" :key="index" :label="el.value">
              {{el.label}}
            </el-radio-button>           
          </el-radio-group>
           <!-- 跳转内容选择 -->
        
        </el-form-item>
        <div class="link-box">
            <div class="box_01_01" v-show="value.jump_type == 1">
                  <el-button size="small" @click="showCom('com_zt_list')">选择专题列表</el-button>
                  <span class="tips" v-text="`${value.relation_title}（内容数：${value.relation_contents}）`"></span>
            </div>
            <div class="box_01_01" v-show="value.jump_type == 2">
                <w-upload-image
                    style="overflow: hidden;"
                    class="upload-img"
                    :imgWidth="1920"
                    :imgHeight="620"
                    :size="10"
                    tipsText="png/jpg格式"
                    v-model="value.bigPic">
                </w-upload-image>
            </div>
            <div class="box_01_01" v-show="value.jump_type == 3">
                  <w-upload-video
                    style="overflow: hidden;"
                    :videoWidth="1920"
                    :videoHeight="620"
                    :size="10"
                    tipsText="mp4格式"
                    v-model="value.video">
                  </w-upload-video>
            </div>
            <div class="box_01_01" v-show="value.jump_type == 4">
                <el-button size="small" @click="showCom('com_wz_list')">选择文章</el-button>
                <span class="tips" v-text="`${value.relation_title}`"></span>
            </div>
            <div class="box_01_01" v-show="value.jump_type == 5">
                <el-input v-model="value.link " placeholder="请输入跳转链接"></el-input>
            </div>
        </div>      
        <component class="box_01_01" @sucss="savePopFn" @close="close" v-bind:is="componentName" v-model="componentData"></component>
    </div>
  
</template>
<script>
import com_zt_list from "../item1/com_zt_list.vue";
import com_wz_list from "../item1/com_wz_list.vue";
export default {
    components: {
        // uploadImageNew
        com_zt_list,
        com_wz_list
    },
    props:{
        value:Object
    },
    data() {
        return{
            componentName:'',
            componentData:{},
            btns:[
                {label:'专题列表',value:'1'},
                {label:'大图',value:'2'},
                {label:'视频',value:'3'},
                {label:'文章',value:'4'},
                {label:'链接',value:'5'},
            ],
            isDisabledRadio:false,
        }
    },


    methods: {
        close(){
            this.showCom('');
        },
        showCom(n,o){
            this.componentName = n || '';        
            this.componentData = o || {};
        },
        zipInfo(v1, v2) {
            this.value.zip = v2
        },
        savePopFn (da) {
            this.close();
            if(!da){
                return
            }
            if(this.value.jump_type == 1 || this.value.jump_type==4){
                this.value.jump_to = da.id;
                this.value.relation_title = da.title
                this.value.relation_contents = da.relation_subject_contents
            }

        },
    },
};
</script>
<style lang='scss'>
.box_01_01{
    margin-left: 100px;
}
.box_01_02{
    display: flex;
}
.box_01_03{
    display: inline-block;
    vertical-align: top;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    // width: 115px;
    // width: 9.5%;
    min-width: 100px;
}
</style>